import { setFlatPreviewFailedAction as setFlatPreviewFailedOperation } from 'editor/src/store/editorModules/preview/slice';

export default setFlatPreviewFailedOperation;
